"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _OwnerType = require("../../../Shared/Models/OwnerType");
var _RepoPanelServiceTreePicker = _interopRequireDefault(require("./RepoPanelServiceTreePicker"));
var _RepoPanelOwnerPicker = _interopRequireDefault(require("./RepoPanelOwnerPicker"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var EditableAssignmentChoiceGroup = function EditableAssignmentChoiceGroup(props) {
  var _props$isReadonly;
  var ownerPickerProps = props.ownerPickerProps,
    serviceTreePickerProps = props.serviceTreePickerProps;
  return /*#__PURE__*/React.createElement(_react2.Stack, null, /*#__PURE__*/React.createElement(_react2.ChoiceGroup, {
    disabled: (_props$isReadonly = props.isReadonly) !== null && _props$isReadonly !== void 0 ? _props$isReadonly : props.isLoading,
    selectedKey: props.ownerType,
    onChange: function onChange(ev, option) {
      return option && props.setOwnerType(option.key);
    },
    options: [{
      key: _OwnerType.OwnerType.SERVICE,
      onRenderField: function onRenderField(servicesChoiceProps, render) {
        return /*#__PURE__*/React.createElement("div", null, render === null || render === void 0 ? void 0 : render(servicesChoiceProps), /*#__PURE__*/React.createElement(_RepoPanelServiceTreePicker.default, {
          ownerType: props.ownerType,
          serviceTreePickerProps: serviceTreePickerProps
        }));
      },
      text: t("repositoryOwnerPanel.assign.service.title")
    }, {
      key: _OwnerType.OwnerType.PERSON,
      onRenderField: function onRenderField(ownersChoiceProps, render) {
        return /*#__PURE__*/React.createElement("div", null, render === null || render === void 0 ? void 0 : render(ownersChoiceProps), /*#__PURE__*/React.createElement(_RepoPanelOwnerPicker.default, {
          ownerType: props.ownerType,
          ownerPickerProps: ownerPickerProps
        }));
      },
      text: t("repositoryOwnerPanel.assign.repositoryOwner.title")
    }]
  }));
};
var _default = EditableAssignmentChoiceGroup;
exports.default = _default;